import { render, staticRenderFns } from "./SrRadioActive.vue?vue&type=template&id=2a2637f4"
import script from "./SrRadioActive.vue?vue&type=script&lang=js"
export * from "./SrRadioActive.vue?vue&type=script&lang=js"
import style0 from "./SrRadioActive.vue?vue&type=style&index=0&id=2a2637f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports